import { render, staticRenderFns } from "./quiz-config-practice.html?vue&type=template&id=bee9ed92&scoped=true&"
import script from "./quiz-config-practice.vue?vue&type=script&lang=js&"
export * from "./quiz-config-practice.vue?vue&type=script&lang=js&"
import style0 from "./quiz-config-practice.css?vue&type=style&index=0&id=bee9ed92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee9ed92",
  null
  
)

export default component.exports